import { render, staticRenderFns } from "./RemovalCard.vue?vue&type=template&id=59ea2fa8&scoped=true&"
import script from "./RemovalCard.vue?vue&type=script&lang=js&"
export * from "./RemovalCard.vue?vue&type=script&lang=js&"
import style0 from "./RemovalCard.vue?vue&type=style&index=0&id=59ea2fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea2fa8",
  null
  
)

export default component.exports